/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-operations-tag': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M11.575 18.75c-.497 0-.974-.198-1.325-.55L1.8 9.756a1.875 1.875 0 01-.55-1.325V3.125c0-1.036.84-1.875 1.875-1.875h5.306c.497 0 .974.198 1.325.55l8.444 8.444a1.875 1.875 0 010 2.656l-5.3 5.3c-.351.352-.828.55-1.325.55zM3.125 2.5a.625.625 0 00-.625.625v5.306a.62.62 0 00.188.444l8.443 8.444a.625.625 0 00.881 0l5.307-5.306a.625.625 0 000-.882L8.875 2.687a.625.625 0 00-.444-.187H3.125zM6.25 8.75a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm0-3.75a1.25 1.25 0 100 2.5 1.25 1.25 0 000-2.5z"/>'
  }
})
